import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {showAlert} from "../../common/sweetalert/sweetalert";
import {serverLink} from "../../../resources/url";
import {toast} from "react-toastify";
import DataLoader from "../../common/dataLoader/dataLoader";
import DataTable from "../../common/data-table/data-table";
import FinanceSettingsForm from "./finance-settings-form";

function FinanceSettings(props) {
    const [IsLoading, setIsLoading] = useState(true)
    const [IsFormLoading, setIsFormLoading] = useState(false)
    const [paymentList, setPaymentList] = useState([])
    const header = ["S/N", "Payment Name", "Code", "Payment Type ID", "Amount", "Status", "Action"];
    const [formData, setFormData] = useState({
        PAYMENT_ID: "",
        PAYMENT_TYPE: "",
        PAYMENT_TYPE_ID: "",
        PAYMENT_CODE: "",
        PAYMENT_FEE: "",
        PAYMENT_STATUS: "",
        INSERTED_BY: `${props.loginData[0]?.StaffID}`,
    })


    useEffect( () => {
        getData();
    }, [""]);


    const getData = async () => {
        await axios.get(`${serverLink}staff/finance/payment/list`)
            .then((result) => {
                if (result.data.length > 0) {
                    setPaymentList(result.data);
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }

    const  showTable = () => {
        try {
            return paymentList.map((item, index) => {
                return (
                    <tr key={index}>
                        <td className="text-xs font-weight-bold">{index +1}</td>
                        <td className="text-xs font-weight-bold">{item.PAYMENT_TYPE}</td>
                        <td className="text-xs font-weight-bold">{item.PAYMENT_CODE}</td>
                        <td className="text-xs font-weight-bold">{item.PAYMENT_TYPE_ID}</td>
                        <td className="text-xs font-weight-bold">{item.PAYMENT_FEE}</td>
                        <td className={`text-xs font-weight-bold ${item.PAYMENT_STATUS?.toString() ==="1" ? "text-success" : "text-danger"}`}>{item.PAYMENT_STATUS?.toString() ==="1" ? "Active" : "In-Active"}</td>
                        <td className="text-xs font-weight-bold">
                            <a href="#" className={"btn btn-primary btn-sm "} data-bs-toggle="modal" data-bs-target="#modal-report"
                               onClick={() => {
                                   setFormData({
                                       ...formData,
                                       PAYMENT_ID: item.PAYMENT_ID,
                                       PAYMENT_TYPE: item.PAYMENT_TYPE,
                                       PAYMENT_TYPE_ID: item.PAYMENT_TYPE_ID,
                                       PAYMENT_CODE: item.PAYMENT_CODE,
                                       PAYMENT_FEE: item.PAYMENT_FEE,
                                       PAYMENT_STATUS: item.PAYMENT_STATUS,
                                   });
                               }}>
                                Edit
                            </a></td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };



    const onEdit = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value,
        });
    }

    const onSubmit = async () => {
        if (formData.PAYMENT_TYPE.trim() === "") {
            showAlert("EMPTY FIELD", "Please enter payment name", "error");
            return false;
        }

        if (formData.PAYMENT_CODE.trim() === "") {
            showAlert("EMPTY FIELD", "Please enter payment code", "error");
            return false;
        }

        if (formData.PAYMENT_STATUS.toString().trim() === "") {
            showAlert("EMPTY FIELD", "Please select payment status", "error");
            return false;
        }

        if (formData.PAYMENT_ID === "") {
            let sendData = {
                ...formData,
            }
            setIsFormLoading(true);
            await axios
                .post(`${serverLink}staff/finance/payment/add`, sendData)
                .then((result) => {
                    if (result.data.message === "success") {
                        toast.success("Payment Added Successfully");
                        setIsFormLoading(false);
                        getData();
                        document.getElementById("closeModal").click();
                        setFormData({
                            ...formData,
                            PAYMENT_ID: "",
                            PAYMENT_TYPE: "",
                            PAYMENT_TYPE_ID: "",
                            PAYMENT_CODE: "",
                            PAYMENT_FEE: "",
                            PAYMENT_STATUS: "",
                        });

                    } else {
                        setIsFormLoading(false);
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                })
                .catch((error) => {
                    setIsFormLoading(false);
                    showAlert(
                        "NETWORK ERROR",
                        "Please check your connection and try again!",
                        "error"
                    );
                });
        }else{
            let sendData = {
                ...formData,
            }
            setIsFormLoading(true);
            await axios
                .patch(`${serverLink}staff/finance/payment/update`, sendData)
                .then((result) => {
                    if (result.data.message === "success") {
                        toast.success("Payment Updated Successfully");
                        setIsFormLoading(false);
                        getData();
                        document.getElementById("closeModal").click();
                        setFormData({
                            ...formData,
                            PAYMENT_ID: "",
                            PAYMENT_TYPE: "",
                            PAYMENT_TYPE_ID: "",
                            PAYMENT_CODE: "",
                            PAYMENT_FEE: "",
                            PAYMENT_STATUS: "",
                        });
                    } else {
                        setIsFormLoading(false);
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                })
                .catch((error) => {
                    setIsFormLoading(false);
                    showAlert(
                        "NETWORK ERROR",
                        "Please check your connection and try again!",
                        "error"
                    );
                });
        }


    }

    return (
        IsLoading ?
            <div className="container-xl" style={{height: '700px'}}>
                <div className="page-header d-print-none">
                    <DataLoader/>
                </div>
            </div>
            :
            <>
                <div className="container-xl">
                    <div className="page-header d-print-none">
                        <div className="row align-items-center">
                            <div className="col">
                                <div className="page-pretitle">
                                </div>
                                <h2 className="page-title">
                                    Manage Payment Types
                                </h2>
                            </div>
                            <div className="col-auto ms-auto d-print-none">
                                <div className="btn-list">

                                    <a href="#" className="btn btn-primary d-none d-sm-inline-block"  data-bs-toggle="modal" data-bs-target="#modal-report"
                                       onClick={()=>{
                                           setFormData({
                                               ...formData,
                                               PAYMENT_ID: "",
                                               PAYMENT_TYPE: "",
                                               PAYMENT_TYPE_ID: "",
                                               PAYMENT_CODE: "",
                                               PAYMENT_FEE: "",
                                               PAYMENT_STATUS: "",
                                           });
                                       }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24"
                                             viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                                             strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <line x1="12" y1="5" x2="12" y2="19"/>
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                        </svg>
                                        Add Payment Types
                                    </a>
                                    <a href="#" className="btn btn-primary d-sm-none btn-icon" data-bs-toggle="modal"
                                       data-bs-target="#modal-report" aria-label="Create new report">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24"
                                             viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                                             strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <line x1="12" y1="5" x2="12" y2="19"/>
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-body">
                    <div className="container-xl">
                        <div className="row row-deck row-cards">
                            <div className="col-lg-12">
                                <div className="row row-cards">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h3 className="card-title">Payment Types</h3>
                                                <DataTable header={header} body={showTable()} title="Payment Types" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FinanceSettingsForm
                    formData={formData}
                    onEdit={onEdit}
                    onSubmit={onSubmit}
                    IsFormLoading={IsFormLoading}
                />
            </>
    );
}
const mapStateToProps = (state) => {
    return {
        loginData: state.loginDetails,
    };
};
export default connect(mapStateToProps, null)(FinanceSettings);
